module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-enter"
  }, [_c('div', {
    staticClass: "c-inari c-enter__inari",
    class: {
      'c-inari--active': _vm.stage === 6
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__airasia"
  }, [_c('a', {
    attrs: {
      "href": "https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'AirAsia Small Entry Logo');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/airasia.svg"),
      "alt": "AirAsia"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-scroll c-scroll--large c-enter"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "c-form"
  }, [_c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.fnameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.firstName),
      expression: "formData.firstName"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "First name"
    },
    domProps: {
      "value": (_vm.formData.firstName)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'First Name');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter your first name")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.lnameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.lastName),
      expression: "formData.lastName"
    }],
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Last name"
    },
    domProps: {
      "value": (_vm.formData.lastName)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Last Name');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter your last name")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Email Address');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter a valid personal email address")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field",
    class: {
      'c-form-error': _vm.postcodeError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.postcode),
      expression: "formData.postcode"
    }],
    attrs: {
      "type": "number",
      "name": "postcode",
      "id": "postcode",
      "min": "0",
      "max": "9999",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.formData.postcode)
    },
    on: {
      "focus": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Post code');
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please enter a valid postcode within Australia")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field c-input-field--padtop c-checkbox",
    class: {
      'c-form-error': _vm.termsError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.termsConditions),
      expression: "formData.termsConditions"
    }],
    attrs: {
      "type": "checkbox",
      "name": "terms",
      "id": "terms",
      "value": "Agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.termsConditions) ? _vm._i(_vm.formData.termsConditions, "Agree") > -1 : (_vm.formData.termsConditions)
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Terms');
      },
      "change": function($event) {
        var $$a = _vm.formData.termsConditions,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Agree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.termsConditions = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formData.termsConditions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formData, "termsConditions", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('small', {
    staticClass: "c-error-message"
  }, [_vm._v("Please confirm the above.")])]), _vm._v(" "), _c('div', {
    staticClass: "c-input-field c-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.optinSubscription),
      expression: "formData.optinSubscription"
    }],
    attrs: {
      "type": "checkbox",
      "name": "subscribe",
      "id": "subscribe",
      "value": "Agree"
    },
    domProps: {
      "checked": Array.isArray(_vm.formData.optinSubscription) ? _vm._i(_vm.formData.optinSubscription, "Agree") > -1 : (_vm.formData.optinSubscription)
    },
    on: {
      "click": function($event) {
        _vm.$ga.event('SecretScrolls', 'Click', 'Newsletter');
      },
      "change": function($event) {
        var $$a = _vm.formData.optinSubscription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Agree",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.formData.optinSubscription = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.formData.optinSubscription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.formData, "optinSubscription", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "subscribe"
    }
  }, [_vm._v("Yes, I’d like to subscribe to the AirAsia newsletter to receive updates about travel news, deals and offers.")])]), _vm._v(" "), _c('div', {
    staticClass: "c-enter__submit"
  }, [_c('button', {
    staticClass: "c-button c-button--primary c-button--small",
    class: {
      'c-button--loading': _vm.loading
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitEnter($event)
      }
    }
  }, [_vm._v("OPEN THE SECRET SCROLL TO IKIGAI")])])])]), _vm._v(" "), _c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "width": "532.4",
      "height": "81.28",
      "preserveAspectRatio": "xMinYMax meet",
      "viewBox": "0 0 532.4 81.28",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M0 12.28L532.4 0v81.28H0z"
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h3', [_vm._v("You did it!")]), _vm._v(" "), _c('p', [_vm._v("Submit your entry now for a chance to "), _c('span', [_vm._v("WIN 2x return flights to Japan")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("I agree to the "), _c('a', {
    attrs: {
      "href": "https://www.jnto.org.au/app/uploads/2018/06/JNTO_Scrolls_Of_Ikigai_Terms_Conditions_May_24th.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.airasia.com/my/en/about-us/privacy-policy.page",
      "target": "_blank"
    }
  }, [_vm._v("AirAsia's privacy policy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61bd22b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EntryForm.vue
// module id = 64
// module chunks = 0